import React, { createContext, useContext, useState, useEffect } from "react";
import { useCustomerSummary } from "../hooks/useCustomerSummary";
import {
  ICustomer,
  IInspectCustomerData,
  IInspectCustomerDisclose,
} from "../types/customer";
import {
  IInspectedDocumentData,
  IInspectedDocumentDiscloseData,
} from "../types/document";
import { OnBoardStep } from "../types/onboard";
import { ISummaryResponse } from "../types/api/application.type";

const CustomerDetailsContext = createContext<ICustomerDetails | null>(null);

interface ICustomerDetails {
  summary: ISummaryResponse | undefined;
}

export const CustomerDetailsProvider = ({
  children,
  customerId,
  currentStep,
}: {
  children: React.ReactNode;
  customerId: string | undefined;
  currentStep: OnBoardStep;
}) => {
  const customerDetails = useCustomerSummary({
    customerId,
    currentStep,
  });

  return (
    <CustomerDetailsContext.Provider value={customerDetails}>
      {children}
    </CustomerDetailsContext.Provider>
  );
};

export const useCustomerDetailsContext = () => {
  const context = useContext(CustomerDetailsContext);
  if (!context) {
    throw new Error(
      "useCustomerDetailsContext must be used within a CustomerDetailsProvider"
    );
  }
  return context;
};
